import moment from "moment";

import {
  setDashboards,
  setTicketsTeachers,
  setUsersManagement,
  setStudentManagement,
  setTeacherManagement,
  setClassesWithoutTeacher,
  setClassesWithoutTeacherDemo,
  setStudentsManagement,
  setLevelStudent,
} from "../slices/companyManager.slice";
import api from "../../services/api";
import { logout } from "./user.middleware";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { initLoading, endLoading, setError } from "../slices/generics.slice";

export const getDashboards = (filter = "ratingCriteriaId=1") => {
  return async (dispatch) => {
    try {
      const response = await api.get(`dashboards?${filter}`);
      const resp = response?.data?.result?.items;
      dispatch(setDashboards(resp[0]));
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getDashboards", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    }
  };
};

export const getClassWithoutTeacher = (isDemoClass = false) => {
  return async (dispatch) => {
    let type = isDemoClass ? "hometop5demo" : "hometop5";

    const language = localStorage.getItem("i18nextLng");

    try {
      const atualDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.sss");
      const pageNumber = "?pageNumber=1";
      const pageSize = "&pageSize=30";
      const orderBy = "&orderByAsc=originalScheduledDateTimeUTC";
      const startAt = `&startAt=${atualDate}`;
      const classType = `&type=${type}`;
      const hasTeacher = "&hasTeacher=false";
      const lang = `&lang=${language}`;

      const response = await api.get(
        `classSchedulesAgrouped${pageNumber}${pageSize}${startAt}${orderBy}${classType}${hasTeacher}${lang}`,
      );
      const resp = response?.data?.result?.items;

      if (!isDemoClass) {
        await dispatch(setClassesWithoutTeacher(resp));
      } else {
        await dispatch(setClassesWithoutTeacherDemo(resp));
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getClassWithoutTeacher", error);
      dispatch(setError(error.message));
    }
  };
};

/* TeachersManagement */

export const getTeachersById = (id = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`teachermanagement/getbyuser/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result?.items[0];
        return resp;
      }
    } catch (error) {
      console.log("getTeachersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getTeachers = (filter = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    let body = {};
    body.name = filter.name === "" ? null : filter.name.trim();
    body.countryId = filter.country === "" ? null : Number(filter.country);
    body.ratingFrom = filter.ratingFrom === "" ? null : Number(filter.ratingFrom);
    body.ratingTo = filter.ratingTo === "" ? null : Number(filter.ratingTo);
    body.active = filter.status === "" ? null : filter.status === "1" ? true : false;
    body.isTraining = filter?.isTraining === "" ? null : filter?.isTraining === "1" ? false : true;
    body.nativeLanguageId = filter.nativeLanguage === "" ? null : Number(filter.nativeLanguage);
    body.otherLanguageId = filter.otherLanguage === "" ? null : Number(filter.otherLanguage);
    body.levelId = filter.level === "" ? null : Number(filter.level);
    body.firstClass = filter.firstClass === "" ? null : filter.firstClass === "1" ? true : false;
    body.demoClass = filter.demoClass === "" ? null : filter.demoClass === "1" ? true : false;
    body.skip = null;
    body.take = null;

    try {
      const response = await api.post("/teachermanagement/searchTeacher", body);

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        dispatch(setTeacherManagement(resp));
      }
    } catch (error) {
      console.log("getTeachers", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTeachers = (formData = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/teachermanagement", formData);
      return response.data;
    } catch (error) {
      console.log("postTeachers", error);
      dispatch(endLoading());
      throw error.response.data.error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putTeachers = (formData = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put("/teachermanagement", formData);
      return response.data;
    } catch (error) {
      console.log("putTeachers", error);
      dispatch(endLoading());
      throw error.response.data.error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getTicketsTeachers = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`tickets?creatorUserId=${id}&orderByDesc=id`);
      if (response.data.success) {
        const resp = response?.data?.result?.items;
        dispatch(setTicketsTeachers(resp));
      }
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getTicketsTeachers", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getTeacheravailabilities = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`teacheravailabilities/${id}`);
      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getTeacheravailabilities", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTeacheravailabilities = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`teacheravailabilities`, body);

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTeacheravailabilities", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteTeacheravailabilities = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`teacheravailabilities`, body);
      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deleteTeacheravailabilities", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* UsersManagement */

export const getUsers = (filter = 0) => {
  return async (dispatch) => {
    dispatch(initLoading());

    let params = "";

    if (!filter) params = "?skip=0&take=255";
    else params = filter;

    try {
      const response = await api.get(`admin/users${params}`);
      if (response.data.success) {
        const resp = response?.data?.result?.items;
        dispatch(setUsersManagement(resp));
      } else {
        dispatch(setUsersManagement([]));
      }
      return response.data;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsers", error);
      dispatch(setUsersManagement([]));
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getUsersById = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`admin/users/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result?.items[0];
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postUsers = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("admin/users", body);

      if (response.data.success) {
        const resp = response?.data?.result?.items[0];
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postUsers", error);
      dispatch(endLoading());
      throw error;
    }
  };
};

export const putUsers = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put("admin/users", body);

      if (response.data.success) {
        const resp = response?.data?.result?.items[0];
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("putUsers", error);
      dispatch(endLoading());
      throw error;
    }
  };
};

export const deteleUsers = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`admin/users/${id}`);

      const resp = response?.data?.result?.items[0];
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deteleUsers", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* StudentManagement */

export const getStudentManagement = (filter) => {
  return async (dispatch) => {
    let cleanFilter = filter;
    cleanFilter.pageSize = filter.pageSize ? filter.pageSize : 20;
    cleanFilter.pageNumber = filter.pageNumber ? filter.pageNumber : 1;

    Object.keys(cleanFilter).forEach(
      (key) =>
        (cleanFilter[key] === undefined || cleanFilter[key] === "" || cleanFilter[key] === 0) &&
        delete cleanFilter[key],
    );

    cleanFilter.b2bOnly = cleanFilter.companyId || cleanFilter.economicGroupId ? true : cleanFilter.b2bOnly;
    cleanFilter.cancelDate = cleanFilter.b2bOnly ? null : cleanFilter.cancelDate;

    try {
      await dispatch(initLoading());

      const response = await api.post(`studentManagement/searchStudents`, cleanFilter);

      if (response.data.success) {
        dispatch(setStudentsManagement(response?.data?.result));
      } else {
        dispatch(setStudentsManagement([]));
      }
      return response.data;
    } catch (error) {
      console.log("getStudentManagement", error);
      dispatch(setError(error.message));
    } finally {
      await dispatch(endLoading());
    }
  };
};

export const getStudentById = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`studentManagement/getbyuser/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result?.items[0];
        dispatch(setStudentManagement(resp));
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putStudentManagement = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`studentManagement/updatePersonalInformation`, JSON.parse(JSON.stringify(body)));

      if (response.data.success) {
        const resp = response?.data;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("putStudentManagement", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getPaymentHistory = (params) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`studentplans/studentplanpayments/getStudentPlanPaymentByStudentAndPlan`, {
        params,
      });

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postStudentPlansCancel = (id, body, provider) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(
        provider === "stripe" || provider === "stripeBR"
          ? `/studentplans-stripe/${id}/cancel`
          : `/studentplans/${id}/cancel`,
        body,
      );

      if (response.data.success) {
        const resp = response?.data?.result;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postStudentPlansCancelImmediate = (id, body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentplans-stripe/${id}/immediate-cancellation`, body);

      if (response.data.success) {
        const resp = response?.data?.result;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postStudentPlansRefund = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentplans-stripe/${id}/refund-plan`);

      if (response.data.success) {
        const resp = response?.data?.result;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postStudentPlansRenovate = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentplans-stripe/${id}/cancel-revert`);

      if (response.data.success) {
        const resp = response?.data?.result;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getLevelStudent = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`/studentManagement/listStudentLevelGrade?skip=0&take=999999&id=${id}`);
      const resp = response.data.result.items;
      dispatch(setLevelStudent(resp));
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postLevelStudent = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentManagement/createStudentLevelGradeArray`, body);
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putLevelStudent = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`studentManagement/updateStudentLevelGradeArray`, body);
      const resp = response.data.result.items;
      return resp;
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getLevel", error);

      dispatch(setError(error.message));
      dispatch(endLoading());
      return false;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getStudentClass = (id, query) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`classSchedules?studentId=${id}&orderBy=originalScheduledDateTimeUTC&` + query);

      if (response.data.success) {
        const resp = response?.data?.result;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getStudentTeacherFavorite = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`studentManagement/getStudentTeacherFavorite/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postReversePayment = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`classSchedules/classScheduleReversal/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postStudentTeacherFavorite = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentManagement/createStudentTeacherFavorite`, body);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postStudentTeacherRestriction = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentManagement/createStudentTeacherRestriction`, body);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateStudentTeacherFavoriteOrder = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`studentManagement/updateStudentTeacherFavoriteOrder`, body);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateStudentFavoriteTeacherFlag = (id, value) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put("studentManagement/updateStudentFavoriteTeacherFlag/" + id + "/" + value);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteStudentTeacherFavorite = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`studentManagement/deleteStudentTeacherFavorite/${body}`);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteStudentTeacherRestriction = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`studentManagement/deleteStudentTeacherRestriction/${body}`);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getUsersById", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* Parameterization */

export const getParameterization = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get("parameters");

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getParameterization", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putParameterization = (id, body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`parameters/${id}`, { parameterValue: body });

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("putParameterization", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* LingoLanguages */

export const postLingoLanguages = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/lingolanguages`, JSON.stringify(body));

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postLingoLanguages", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putLingoLanguages = (id, body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`/lingolanguages`, JSON.stringify(Object.assign({ id: Number(id) }, body)));

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("putLingoLanguages", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteLingoLanguages = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`/lingolanguages/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deleteLingoLanguages", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* LingoLanguages */
export const getEconomicGroup = (filter) => {
  return async (dispatch) => {
    dispatch(initLoading());

    let body = {};
    body.name = filter.name === "" ? null : filter.name;
    body.code = filter.code === "" ? null : filter.code;
    body.active = filter.active === "" ? null : filter.active === "1" ? true : false;
    body.description = filter.description === "" ? null : filter.description;
    body.skip = null;
    body.take = null;

    try {
      const response = await api.post(`/economicgroups/search`, JSON.stringify(body));

      if (response.data.success) {
        return response?.data?.result?.items.map((item) => ({ ...item, name: decryptIfEncrypted(item.name) }));
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getEconomicGroup", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postEconomicGroup = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/economicgroups`, JSON.stringify(body));

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postEconomicGroup", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putEconomicGroup = (id, body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`/economicgroups`, JSON.stringify(Object.assign({ id: Number(id) }, body)));

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("putEconomicGroup", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteEconomicGroup = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`/economicgroups/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deleteEconomicGroup", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* PriceCountries */
export const getPriceCountries = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`pricecountries/list?skip=0&take=1000`);

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getPriceCountries", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postPriceCountries = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/pricecountries`, JSON.stringify(body));

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postPriceCountries", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putPriceCountries = (id, body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`/pricecountries`, JSON.stringify(Object.assign({ id: Number(id) }, body)));

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("putPriceCountries", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deletePriceCountries = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`/pricecountries/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deletePriceCountries", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* RatingCriterias */
export const postRatingCriterias = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`/ratingCriterias`, JSON.stringify(body));

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postRatingCriterias", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const pustRatingCriterias = (id, body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`/ratingCriterias`, JSON.stringify(Object.assign({ id: Number(id) }, body)));

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("pustRatingCriterias", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteRatingCriterias = (id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.delete(`/ratingCriterias/${id}`);

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deleteRatingCriterias", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* TicketTypes */
export const getTicketTypes = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get(`ticketTypes`);

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getTicketTypes", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postTicketTypes = (type, body, id) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      let response = {};

      if (type === "ticketTypes") {
        response = await api.post(`ticketTypes`, body);
      } else {
        response = await api.post(`ticketTypes/${id}/ticketSubTypes`, body);
      }

      if (response.data.success) {
        const resp = response?.data?.result.items[0];
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("postTicketTypes", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const pustTicketTypes = (type, body, id, subId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      let response = {};

      if (type === "ticketTypes") {
        response = await api.put(`ticketTypes/${id}`, body);
      } else {
        response = await api.put(`ticketTypes/${id}/ticketSubTypes/${subId}`, body);
      }

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("pustTicketTypes", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const deleteTicketTypes = (type, id, subId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      let response = {};

      if (type === "ticketTypes") {
        response = await api.delete(`ticketTypes/${id}`);
      } else {
        response = await api.delete(`ticketTypes/${id}/ticketSubTypes/${subId}`);
      }

      if (response.data.success) {
        const resp = response?.data?.result.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("deleteTicketTypes", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

/* getLingoNotifications */
export const getLingoNotifications = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get("notificationmanager/list?pageNumber=1&pageSize=100");

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getTicketTypes", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putLingoNotification = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`notificationManager`, body);

      if (response.data.success) {
        const resp = response?.data?.result?.items;
        return resp;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName);
            });
          });
        }
        dispatch(logout());
      }
      console.log("getTicketTypes", error);
      dispatch(setError(error.message));
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getMessagePush = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get("/pushtool/getMessages");

      if (response.data.success) {
        return response?.data?.result?.items;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => caches.delete(cacheName));
          });
        }
        dispatch(logout());
      }
      console.log("getMessagePush", error);
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postMessagePush = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/pushtool/createMessage", body);

      if (response.data.success) {
        return response?.data?.result?.items;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => caches.delete(cacheName));
          });
        }
        dispatch(logout());
      }
      console.log("postMessagePush", error);
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postMessageSendPush = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post("/pushtool/sendMessage", body);

      if (response.data.success) {
        return true;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => caches.delete(cacheName));
          });
        }
        dispatch(logout());
      }
      console.log("postMessageSendPush", error);
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getLogMessagePush = (messageId) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.get("/pushtool/getMessagesLog", {
        params: { messageId: messageId },
      });

      if (response.data.success) {
        return response?.data?.result?.items;
      }
    } catch (error) {
      if (error.message === "Network Error") {
        if (window?.caches) {
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => caches.delete(cacheName));
          });
        }
        dispatch(logout());
      }
      console.log("getLogMessagePush", error);
      dispatch(endLoading());
    } finally {
      dispatch(endLoading());
    }
  };
};

export const postFormReport = (payload) => {
  return async (dispatch) => {
    try {
      await dispatch(initLoading());

      const newPayload = {
        ...payload,
        contentId: payload.contentId === "null" ? null : payload.contentId,
      };

      const { data } = await api.post("/classSchedulesForm/setFormReport", newPayload);

      return data.ok;
    } catch (error) {
      console.log("postFormReport", error);
    } finally {
      dispatch(endLoading());
    }
  };
};
